// extracted by mini-css-extract-plugin
module.exports = {"dashboardPage":"src-AdminPanel-pages-Search-styles-style-module__dashboardPage--1lSHm","elasticSearch":"src-AdminPanel-pages-Search-styles-style-module__elasticSearch--1G5sF"};